var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg49(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.37 70.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{opacity:0.1;}.cls-2,.cls-3{fill:#00a193;}.cls-4{fill:#f5a338;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.36,
    y: 1.17,
    width: 4.67,
    height: 4.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.52,10.51H28a9.34,9.34,0,0,1,9.34-9.34h7V5.84Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23.35 25.68 7 25.68 7 15.18 11.67 9.34 18.68 9.34 23.35 15.18 23.35 25.68"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.67,
    y: 1.17,
    width: 7,
    height: 8.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 31.52,
    y: 10.51,
    width: 7,
    height: 4.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "31.52 15.18 38.52 15.18 44.36 21.01 44.36 25.68 28.02 25.68 28.02 18.68 31.52 15.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.37,50.2H56.54a7.1,7.1,0,0,0-3.17.74,7.1,7.1,0,0,1-6.35,0,7.1,7.1,0,0,0-3.17-.74H42A5.83,5.83,0,0,0,36.19,56v7A5.83,5.83,0,0,0,42,68.87h1.83A7.1,7.1,0,0,0,47,68.13a7.1,7.1,0,0,1,6.35,0,7.1,7.1,0,0,0,3.17.74h1.83A5.83,5.83,0,0,0,64.2,63V56A5.83,5.83,0,0,0,58.37,50.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 57.2,
    y: 53.7,
    width: 2.33,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 45.53,
    y: 53.7,
    width: 2.33,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 40.86,
    y: 54.87,
    width: 2.33,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 52.53,
    y: 54.87,
    width: 2.33,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.2,
    y: 53.7,
    width: 2.33,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.53,
    y: 53.7,
    width: 2.33,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.86,
    y: 54.87,
    width: 2.33,
    height: 2.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 52.53,
    y: 54.87,
    width: 2.33,
    height: 2.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.17,31.52H3.64L8.18,66.69a1.17,1.17,0,0,0,1.16,1H36.82A7,7,0,0,0,42,70h1.83a8.35,8.35,0,0,0,3.7-.87,6,6,0,0,1,5.3,0,8.27,8.27,0,0,0,3.69.87h1.83a7,7,0,0,0,7-7V56a7,7,0,0,0-7-7H56.54a8.27,8.27,0,0,0-3.69.87,6,6,0,0,1-5.3,0,8.37,8.37,0,0,0-2.1-.7l2.27-17.68H50.2a1.16,1.16,0,0,0,1.16-1.17V25.68a1.17,1.17,0,0,0-1.16-1.17H45.53V21a1.19,1.19,0,0,0-.34-.82l-5.5-5.5V11.07l1.77-1.42,3,6,2.09-1L43.32,8.16,44.77,7H49A1.17,1.17,0,0,0,50.2,5.84V1.17A1.17,1.17,0,0,0,49,0H37.36A10.53,10.53,0,0,0,26.85,10.51,1.16,1.16,0,0,0,28,11.67h2.33v3l-3.16,3.16a1.17,1.17,0,0,0-.34.83v5.83H24.51V15.18a1.26,1.26,0,0,0-.08-.43l-.07-.13a1,1,0,0,0-.1-.17L19.85,8.93V1.17A1.17,1.17,0,0,0,18.68,0h-7a1.16,1.16,0,0,0-1.16,1.17V8.93L6.09,14.45l-.1.17-.07.13a1.26,1.26,0,0,0-.08.43v9.33H1.17A1.17,1.17,0,0,0,0,25.68v4.67A1.17,1.17,0,0,0,1.17,31.52Zm57.2,36.19H56.54a5.94,5.94,0,0,1-2.65-.63,8.28,8.28,0,0,0-7.39,0,5.94,5.94,0,0,1-2.65.63H42A4.67,4.67,0,0,1,37.36,63v-1.8A6.94,6.94,0,0,0,42,63h1.83a8.35,8.35,0,0,0,3.7-.87,6,6,0,0,1,5.3,0,8.27,8.27,0,0,0,3.69.87h1.83A7,7,0,0,0,63,61.24V63A4.67,4.67,0,0,1,58.37,67.71ZM53.89,52a6.08,6.08,0,0,1,2.65-.63h1.83a4.67,4.67,0,1,1,0,9.34H56.54a5.93,5.93,0,0,1-2.65-.62,8.28,8.28,0,0,0-7.39,0,5.93,5.93,0,0,1-2.65.62H42a4.67,4.67,0,0,1,0-9.34h1.83A6.08,6.08,0,0,1,46.5,52,8.28,8.28,0,0,0,53.89,52ZM43.11,49H42a7,7,0,0,0-7,7v7a6.89,6.89,0,0,0,.41,2.33H10.36L6,31.52h5.67v21a4.67,4.67,0,0,0,4.67,4.67H28a4.67,4.67,0,0,0,4.67-4.67V42.75l3.05,1.52a3.72,3.72,0,0,0,5-1.69v0a3.79,3.79,0,0,0-1.68-5.08L32.69,34.3V31.52H45.37ZM28,26.85h2.33V35a1.17,1.17,0,0,0,.65,1l7,3.5a1.44,1.44,0,0,1,.72.83,1.49,1.49,0,0,1-.12,1.17,1.36,1.36,0,0,1-1.83.61h0L32,39.81a1.17,1.17,0,0,0-1.56.54,1.13,1.13,0,0,0-.12.51V52.53A2.33,2.33,0,0,1,28,54.87V44.36H25.68V54.87H23.35V44.36H21V54.87H18.68V44.36H16.34V54.87A2.33,2.33,0,0,1,14,52.53V26.85Zm21,2.33H32.69V26.85H49ZM47.86,4.67H45.53V2.33h2.33ZM37.36,2.33h5.83v3L38.11,9.34H29.27A8.19,8.19,0,0,1,37.36,2.33Zm0,9.34V14H32.69V11.67Zm-8.18,7.49L32,16.34h6l5.15,5.16v3h-14ZM12.23,10.51h5.89l2.8,3.5H9.43Zm.61-8.18h4.67V8.17H12.84Zm-4.67,14h14v8.17h-14ZM2.33,26.85h9.34v2.33H2.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg49);
export default __webpack_public_path__ + "static/media/49.e602d23585af7549c7c131166250780e.svg";
export { ForwardRef as ReactComponent };